import type { SVGProps } from "react";
export interface AppleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AppleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AppleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.977 13.63c0-1.574.776-2.972 1.971-3.81-.952-.775-2.239-.917-3.45-.35l-.319.168c-.576.334-1.186.574-1.869.574-.513 0-.984-.134-1.43-.343l-.438-.231c-1.817-1.056-3.934-.47-4.82 1.617-.716 1.684-.624 3.577.055 5.437.567 1.554 1.223 2.588 2.372 3.733l.108.1c.56.465 1.367.491 2.171-.068.587-.408 1.239-.707 1.982-.707.744 0 1.396.299 1.983.707.858.596 1.719.526 2.28-.032.862-.86 1.446-1.658 1.923-2.659a4.63 4.63 0 0 1-2.52-4.137m2.25 0c0 1.175.819 2.124 1.863 2.33.098.008.198.024.296.06.583.213.883.86.67 1.443l-.004.012c-.676 1.847-1.506 3.163-2.891 4.544-1.502 1.496-3.615 1.355-5.152.287-.384-.267-.588-.306-.699-.306s-.314.04-.697.306c-1.441 1.002-3.388 1.188-4.864-.025l-.288-.262c-1.389-1.384-2.221-2.702-2.898-4.556-.82-2.246-1.007-4.749-.013-7.089 1.444-3.397 5.098-4.382 8.023-2.682l.26.138c.231.108.375.132.477.132.136 0 .347-.042.738-.27l.254-.139c2.642-1.378 5.822-.64 7.412 2.105a1.126 1.126 0 0 1-.712 1.658c-1.002.24-1.775 1.172-1.775 2.313"
      />
      <path
        fill={color}
        d="M12.116 2.116C13.05 1.182 14.376.763 15.822.9l.29.036.18.04c.405.13.71.48.772.91.227 1.558-.183 3.001-1.18 3.998-.996.996-2.439 1.405-3.997 1.179a1.125 1.125 0 0 1-.95-.952c-.227-1.558.183-3 1.179-3.996m2.723 1.043c-.493.078-.87.284-1.133.548-.263.263-.47.64-.547 1.132.493-.078.871-.282 1.135-.545.263-.264.467-.642.545-1.135"
      />
    </svg>
  );
}
